import umbraco from '~/lib/api/umbraco';
import { UmbracoTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/umbraco/utils';

export default function getFrame(signal: AbortSignal | undefined, asPath?: string) {
    const url = getUrl('/content/frame');
    url.searchParams.append('url', asPath ?? '/'); // When supporting multiple languages, this will need to be changed

    return umbraco.get(url, { signal }).json<UmbracoTypes.IFrame>();
}
